// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF","Settings":"Settings_Settings__GthuT","SettingsBtn":"Settings_SettingsBtn__3ujSU"};